import type { Locale } from '../locales';
import { enUSMessages } from './en-US';

export const messages: Record<Locale, Record<string, string>> = {
  'en-US': enUSMessages,
};
